export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 border border-background-200/70 rounded-3xl p-8 md:p-12">
          <div className="flex-1 w-full flex justify-center lg:justify-start">
            <div className="relative w-full max-w-[320px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20comic%20reading%20app%20interface%20with%20continuous%20scroll%20webtoon%20layout%2C%20warm%20coral%20and%20orange%20color%20scheme%2C%20flat%20vector%20art%20style%2C%20modern%20mobile%20UI%20with%20comic%20panels%20flowing%20downward%2C%20clean%20minimal%20design%2C%20soft%20pastel%20background&width=640&height=1136&seq=app-mobile-2026&orientation=portrait"
                alt="布丁漫画网移动端阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 flex flex-col items-start gap-5">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
              随时随地阅读
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
              移动端畅读
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              布丁漫画网完美适配手机和平板浏览器，无需下载安装任何App，
              直接通过浏览器即可享受<strong className="text-foreground-900">布丁漫画下拉式连续阅读</strong>的极致体验。
              移动端经过专项优化，触屏滑动更流畅，阅读进度自动保存，
              换设备也能接着上次继续看。布丁漫画下拉式免费看的便捷体验，
              让你的碎片时间也能畅享精彩漫画。
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <div className="flex items-center gap-3 px-6 py-3 rounded-full bg-background-100 border border-background-200/70 cursor-default">
                <i className="ri-smartphone-line text-xl text-foreground-700"></i>
                <div>
                  <div className="text-xs text-foreground-400">手机端</div>
                  <div className="text-sm font-semibold text-foreground-900">浏览器直接访问</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-6 py-3 rounded-full bg-background-100 border border-background-200/70 cursor-default">
                <i className="ri-tablet-line text-xl text-foreground-700"></i>
                <div>
                  <div className="text-xs text-foreground-400">平板端</div>
                  <div className="text-sm font-semibold text-foreground-900">大屏沉浸阅读</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}